import {useMediaQuery} from '@mui/material'
import {FC} from 'react'
import {names} from 'shared/lib'
import {text} from 'shared/mirrors/text'
import {Button} from 'shared/ui/buttons'
import {Logo} from 'shared/ui/icons'
import {CreateAccount} from 'widgets/createAccount'
import backgroundMP4 from './assets/background.mp4'
import backgroundWEBM from './assets/background.webm'
import backgroundMobile from './assets/mobile-background.webp'
import secureSSl from './assets/secure-ssl.png'
import styles from './styles.module.scss'

export const CreateAccountSection: FC<{className?: string}> = ({className}) => {
  const isTablet = useMediaQuery(`(max-width: ${styles.isTablet})`)

  return (
    <div className={names(styles.container, className)}>
      {
        isTablet ? <MobileBackground /> : <>
          <video className={styles.background} autoPlay loop muted playsInline>
            <source src={backgroundWEBM} type='video/webm' />
            <source src={backgroundMP4} type='video/mp4' />
            Your browser does not support the video tag.
          </video>
          <div className={styles.background_gradient} />
        </>
      }
      <div className={styles.contentContainer}>
        <CreateAccount />
        <div className={styles.rightContainer}>
          <Button as='link' to='/auth' className={styles.signInBtn} styleType='secondary'>Login</Button>
          <div className={styles.textContainer}>
            <h1 className={styles.mainTitle}>
              We give you more than a chat
            </h1>
            <h2 className={styles.caption}>
              {text.main.siteName} - space for unique connections
            </h2>
          </div>
          <img width={69} src={secureSSl} alt='secure ssl certificate' />
        </div>
      </div>
    </div>
  )
}

export const CreateAccountSectionMobile: FC = () => {
  return (
    <div style={{position: 'relative'}}>
      <MobileBackground />
      <div className={styles.container__mobile}>
        <div className={styles.headerContainer}>
          <div className={styles.logoContainer}>
            <div className={styles.logo}><Logo /></div>
            <h3 className={styles.logoContainer__name}>{text.main.siteName}</h3>
          </div>
          <Button as='link' to='/auth' className={styles.signInBtn} styleType='secondary'>Login</Button>
        </div>
        <h1 className={styles.mainTitle}>
          We give you <br /> more than a chat
        </h1>
        <CreateAccount />
      </div>
    </div>
  )
}

const MobileBackground = () => {
  return (
    <>
      <img className={styles.mobileBackgroundImg} src={backgroundMobile} alt='background-mobile' />
      <div className={styles.mobileBackgroundImg_gradient} />
    </>
  )
}